import * as types from './types'
import { Delivery } from './types'

export const loadDeliveries = (deliveries: Delivery[]) => ({
  type: types.LOAD_DELIVERIES,
  payload: deliveries,
})
